import { regionList } from '../../api/region'

// initial state
const state = {
  items: [],
}

// mutations
const mutations = {
  saveRegionItems(state, items) {
    state.items = items
  },
  clearRegionItems(state) {
    state.item = []
  },
}

// actions
const actions = {
  fetchRegions({ commit, state }) {
    regionList().then(
      (response) => {
        if (response.regions) {
          if( response.regions[0] && 
              response.regions[0].regions[0] && 
              response.regions[0].regions[0].regions[0] &&
              response.regions[0].regions[0].regions[0].regions[0] ){
              
            let subRegions = response.regions[0]
            if(subRegions.length=1){
              let minSubRegions = subRegions.regions[0]
              commit('saveRegionItems', minSubRegions.regions)
            }else{
              commit('saveRegionItems', subRegions.regions)
            }
          }else{
            commit('saveRegionItems', response.regions)
          }
        }
      }, (error) => {
      }
    )
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/region.js